export default __webpack_public_path__ + "static/media/bajookieland-vid.d98fe7bb.mp4";